import { updatesItems } from '@/mocks/home';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="section-container">
        <h2 className="section-title">最新动态</h2>
        <p className="section-subtitle">平台更新、新作上架与功能升级的最新消息</p>

        <div className="max-w-3xl mx-auto">
          {updatesItems.map((item, i) => (
            <div
              key={item.id}
              className="relative flex gap-4 pb-6 last:pb-0"
            >
              <div className="flex flex-col items-center">
                <div className={`w-2.5 h-2.5 rounded-full mt-1.5 flex-shrink-0 ${
                  i === 0 ? 'bg-accent-500 ring-4 ring-accent-100' : 'bg-background-300'
                }`}></div>
                {i < updatesItems.length - 1 && (
                  <div className="w-px flex-1 bg-background-200 mt-1.5"></div>
                )}
              </div>

              <div className="flex-1 min-w-0 pb-2">
                <span className="text-xs text-foreground-400 whitespace-nowrap">{item.date}</span>
                <h3 className="font-heading text-sm md:text-base font-bold text-foreground-950 mt-0.5 mb-1">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}